const emitir_quadro_demonstrativo = [
  {
    path: "/emitir-quadro-demonstrativo",
    name: "emitir_quadro_demonstrativo",
    meta: {
      allowedPermissions: ["atasfinais_quadro_demonstrativo"],
      breadCrumb: "Processo de Resultado Final - Encerramento do Ano Letivo",
    },
    component: () =>
      import("@/views/EmitirQuadroDemonstrativo/EmitirQuadroDemonstrativo.vue"),
  },
];

export { emitir_quadro_demonstrativo };
